import type { Result } from 'modules/core/lib/handleMutation'

type Handler<T extends unknown[]> = (
  ...args: T
) => Promise<unknown> | Promise<Result<unknown>> | void

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null
}

const isResult = <T>(value: unknown): value is Result<T> => {
  if (!isObject(value)) return false
  if ('success' in value && typeof value.success === 'boolean') {
    if (value.success) {
      return 'data' in value
    } else {
      return 'errors' in value && Array.isArray(value.errors)
    }
  }
  return false
}

export const handleFormSubmit = async <T extends unknown[]>(
  fn: Handler<T>,
  ...args: T
): Promise<Result<unknown>> => {
  try {
    const result = await fn(...args)

    if (result === undefined) {
      return { success: true, data: undefined }
    }

    if (isResult(result)) {
      return result
    }

    return { success: true, data: result }
  } catch (err) {
    return { success: false, errors: [] }
  }
}
